// 劫持XHR，执行注入的函数，从aegis hack-http精简过来
interface HackXHROptions {
  open?: (xhr: XMLHttpRequest) => void;
  send?: (xhr: XMLHttpRequest, body: any) => void;
}

declare global {
  interface XMLHttpRequest {
    _requestHeaderKeys?: string[];
  }
}

let alreadyHackXHR = false;
const hackXHROptionsList: HackXHROptions[] = [];

export const HEADER_IGNORE_XHR = 'ignore-xhr-report';
export const IGNORE_HEADER_LIST = [HEADER_IGNORE_XHR];

export const hackXHR = function (options: HackXHROptions) {
  hackXHROptionsList.push(options);
  if (alreadyHackXHR || !window.XMLHttpRequest) return;
  alreadyHackXHR = true;

  const originSend = window.XMLHttpRequest.prototype.send;
  const originOpen = window.XMLHttpRequest.prototype.open;
  const originSetRequestHeader = window.XMLHttpRequest.prototype.setRequestHeader;
  window.XMLHttpRequest.prototype.open = function aegisFakeOpen() {
    // const url = arguments[1];
    // Aegis自己发的请求不做操作
    // @ts-ignore
    if (!this.sendByAegis) {
      for (let i = 0; i < hackXHROptionsList.length; i++) {
        const options = hackXHROptionsList[i];
        try {
          typeof options.open === 'function' && options.open(this);
        } catch (e) {}
      }
    }

    // @ts-ignore
    return originOpen.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.setRequestHeader = function aegisFakeXHRSetRequestHeader() {
    const requestHeaderKey = arguments[0];
    // 存储requestHeaderKey到XMLHttpRequest实例中的一个属性中
    this._requestHeaderKeys = this._requestHeaderKeys || [];
    this._requestHeaderKeys.push(requestHeaderKey);
    if (IGNORE_HEADER_LIST.indexOf(requestHeaderKey) > -1) {
      return;
    }
    // @ts-ignore
    return originSetRequestHeader.apply(this, arguments);
  };

  window.XMLHttpRequest.prototype.send = function aegisFakeSend() {
    // Aegis自己发的请求不做操作
    // @ts-ignore
    if (!this.sendByAegis) {
      for (let i = 0; i < hackXHROptionsList.length; i++) {
        const options = hackXHROptionsList[i];
        try {
          typeof options.send === 'function' && options.send(this, arguments[0]);
        } catch (e) {}
      }
    }

    // @ts-ignore
    originSend.apply(this, arguments);
  };
};

// 劫持fetch，执行注入的函数
interface HackFetchOptions {
  beforeFetch?: (url: string, option: RequestInit) => void;
  then?: (res: Response, url: string, option?: RequestInit) => void;
  catch?: (err: any, url: string, option?: RequestInit) => void;
}
let alreadyHackFetch = false;
const hackFetchOptionsList: HackFetchOptions[] = [];
export const hackFetch = function (option: HackFetchOptions) {
  hackFetchOptionsList.push(option);
  if (alreadyHackFetch || !window.fetch) return;
  alreadyHackFetch = true;

  const originFetch = window.fetch;
  (window as any).fetch = function aegisFakeFetch(url: string, fetchOption = {}) {
    for (let i = 0; i < hackFetchOptionsList.length; i++) {
      const option = hackFetchOptionsList[i];
      try {
        typeof option.beforeFetch === 'function' && option.beforeFetch(url, fetchOption);
      } catch (e) {}
    }
    return originFetch(url, fetchOption)
      .then((res) => {
        for (let i = 0; i < hackFetchOptionsList.length; i++) {
          const option = hackFetchOptionsList[i];
          try {
            typeof option.then === 'function'
            && option.then(res, url, fetchOption);
          } catch (e) {}
        }
        // 原封不动返回res
        return res;
      })
      .catch((err) => {
        for (let i = 0; i < hackFetchOptionsList.length; i++) {
          const option = hackFetchOptionsList[i];
          try {
            typeof option.catch === 'function'
            && option.catch(err, url, fetchOption);
          } catch (e) {}
        }
        // 原封不动继续抛出err
        throw err;
      });
  };
};
